import { cobalt } from '~/scopes/campaign/data/metals/cobalt'

import translations from './human.translations'
import type { Journey } from './types'

const t = translations

/**
 * Cobalt, mine to shop counter. Coordinates are invented and the pins all carry the
 * impact's own icon; see `.claude/rules/guided-mining.md`.
 */
export const humanJourney: Journey = {
  impact: 'human',
  label: t.label,
  metal: cobalt,
  stops: [
    {
      slug: 'intro',
      label: t.introLabel,
      title: t.introTitle,
      body: t.introBody,
      bodyAfter: t.introBodyTwo,
      cta: t.introCta,
      location: {
        coordinates: [26.28, -10.72],
        zoom: 7,
      },
    },
    {
      slug: 'extraction',
      label: t.extractionLabel,
      title: t.extractionTitle,
      place: t.extractionPlace,
      body: t.extractionBody,
      citations: [1, 2, 4],
      cta: t.extractionCta,
      location: {
        // Copied from `cobalt.ts`, not imported: this pair is a staging choice.
        coordinates: [26.28, -10.72],
        zoom: 9,
        pin: true,
      },
    },
    {
      slug: 'refining',
      label: t.refiningLabel,
      title: t.refiningTitle,
      place: t.refiningPlace,
      body: t.refiningBody,
      citations: [3, 9, 10],
      cta: t.refiningCta,
      location: {
        // Jiaozuo, not the Henan centroid, which sits almost on Zhengzhou.
        coordinates: [113.24, 35.22],
        zoom: 9,
        pin: true,
      },
    },
    {
      slug: 'manufacture',
      label: t.manufactureLabel,
      title: t.manufactureTitle,
      place: t.manufacturePlace,
      body: t.manufactureBody,
      citations: [2, 5, 11],
      cta: t.manufactureCta,
      location: {
        coordinates: [114.06, 22.54],
        zoom: 9,
        pin: true,
      },
    },
    {
      slug: 'assembly',
      label: t.assemblyLabel,
      title: t.assemblyTitle,
      place: t.assemblyPlace,
      body: t.assemblyBody,
      citations: [6, 7],
      cta: t.assemblyCta,
      location: {
        coordinates: [113.63, 34.75],
        zoom: 9,
        pin: true,
      },
    },
    {
      // The last stop, so its CTA finishes into the metal's extended reader.
      slug: 'sale',
      label: t.saleLabel,
      title: t.saleTitle,
      place: t.salePlace,
      body: t.saleBody,
      citations: [1, 5],
      cta: t.saleCta,
      location: {
        // Apple Champs-Élysées. (Superseded: Fifth Avenue, which the V2 copy
        // moved to Paris — and which gold's own sale stop now holds.)
        coordinates: [2.3009, 48.8712],
        zoom: 9,
        pin: true,
      },
    },
  ],
}
